import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { ScheduleRequestListItem } from '@frontend/schedule-helpers';
import { isEmpty } from '@frontend/validation';
import { useModalControl } from '@frontend/design-system';
import { PreferenceBasedScheduleRequestDetails } from './preference-based-request-item-details';
import { ScheduleRequestItemDetails } from './request-item-details';

interface ScheduleRequestDetailsProps {
  listItem: ScheduleRequestListItem;
  scheduleRequestId: string;
  requestVersion: string;
  locationId: string;
  isPaymentsEnabled: boolean;
  patientContactedAt?: string;
  dismissRequestModalProps: ReturnType<typeof useModalControl>;
  onMessage: (updateStatus: boolean) => void;
  onPhoneCall: () => void;
  onCompleteRequest: () => void;
  onReviewCallLog: () => void;
  onViewConversation: () => void;
}

export const ScheduleRequestDetails = ({
  listItem,
  scheduleRequestId,
  requestVersion,
  locationId,
  isPaymentsEnabled,
  patientContactedAt,
  dismissRequestModalProps,
  onCompleteRequest,
  onPhoneCall,
  onMessage,
  onReviewCallLog,
  onViewConversation,
}: ScheduleRequestDetailsProps) => {
  const { isPreferenceBasedRequestEnabled } = SchedulerV3.Helpers.useGetPreferenceBasedRequestFeatureFlagDetails();
  const isPreferenceBasedRequest = !isEmpty(listItem.aiRequestDetails);

  if (isPreferenceBasedRequestEnabled && isPreferenceBasedRequest) {
    return (
      <PreferenceBasedScheduleRequestDetails
        listItem={listItem}
        patientContactedAt={patientContactedAt}
        dismissRequestModalProps={dismissRequestModalProps}
        onCompleteRequest={onCompleteRequest}
        onPhoneCall={onPhoneCall}
        onMessage={onMessage}
        onReviewCallLog={onReviewCallLog}
        onViewConversation={onViewConversation}
      />
    );
  }

  return (
    <ScheduleRequestItemDetails
      scheduleRequestId={scheduleRequestId}
      requestVersion={requestVersion}
      locationId={locationId}
      isPaymentsEnabled={isPaymentsEnabled}
    />
  );
};
